<template lang="html">
   <div class="claimtypes">
      <ModalForm :showModal="showModal" :action="ClaimType.wizard.action">
            <template slot="form">
               <CustomForm 
                  :pages="ClaimType.wizard.pages" 
                  :action="ClaimType.wizard.action" 
                  :buttonText="ClaimType.wizard.actionBtn" 
                  :showTitle="false">
               </CustomForm>
            </template>
      </ModalForm>

      <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
         <div></div>
         <div class="d-none d-md-block">
            <button class="btn btn-sm pd-x-15 btn-white btn-uppercase" @click="openAddClaimTypeModal()">
               <i data-feather="mail" class="wd-10 mg-r-5"></i> Add Claim Type
            </button>
            <!-- <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5">
               <i data-feather="printer" class="wd-10 mg-r-5"></i> Download Report
            </button> -->
         </div>
      </div>

      <div class="contents">
         <CustomTable :tableFields="ClaimType.table.table_fields" 
            :tableData="claimTypes" 
            :title="ClaimType.table.title" 
            :subtitle="ClaimType.table.subtitle" 
            :searchFields="ClaimType.table.searchFields"
            :rowData="ClaimType.table.rowData">
         </CustomTable>
      </div>
   </div>
</template>

<script>
export default {
	async created() {
		this.ClaimType = Models.claimtypes;
		let _this = this;

		this.claimTypes = [];

		// if specified action is complete clear form data and stop loader
		Event.$on("form:submit", async payload => {
			if (payload.action === this.ClaimType.wizard.action) {
				await this.addClaimType(payload.formData);
				this.showModal = false;
			}
		});

		Event.$on("modal:close", async payload => {
			console.log("Closing modal");
			this.showModal = false;
		});

		Event.$on("claimType:view", payload => {
			this.$router.push({
				name: "Configs-Insurance-ViewClaimtype",
				params: { id: payload.claimtype.claim_type_code }
			});
		});
	},
	data() {
		return {
			ClaimType: {},
			claimTypes: [],
			formData: {},
			showModal: false
		};
	},
	methods: {

      fetchClaimTypes () {
         return new Promise(async (resolve, reject) => {
				try {
					let res = await req.callServerSecure({
						resource: "claim_type",
						action: "list",
						data: {},
						meta_data: {}
					});

               this.claimTypes = res.data.result.claim_types
					resolve(true);
				} catch (err) {
					reject(err);
				}
			});
      },
		openAddClaimTypeModal() {
			this.showModal = true;
		},
		addClaimType(data) {
			return new Promise(async (resolve, reject) => {
				try {
					let res = await req.callServerSecure({
						resource: "claim_type",
						action: "add",
						data: {
						   claim_type_code :data.claim_type_code,
                           claim_type_name :data.claim_type_name,
                         claim_type_description :data.claim_type_description
						}
					});

               await this.fetchClaimTypes()
					notification.notify("success","Claim Type Added",`Claim Type ${data.claim_type_name} successfully added`);
					Event.$emit("form:action-complete", {action: this.ClaimType.wizard.action,clear: true});
					this.showModal = false;
				} catch (err) {
					console.log(err);
					Event.$emit("form:action-error", {action: this.ClaimType.wizard.action});
				}
			});
		}
	},
	async mounted() {
      await this.fetchClaimTypes()
		Event.$emit("loader:show", false);
	}
};
</script>

<style lang="less">
.claimtypes {
}
</style>